module.exports = __webpack_public_path__ + "static/media/B2.782a81b4.png";